import {useEffect, useState} from 'react';

const DEFAULT_TEMPLATE_WIDTH = 1000;

export const useCardVideo = (fabricArt, videoRef) => {
  const [videoStyles, setVideoStyles] = useState({width: 0, top: 0, left: 0});
  const backgroundImage = fabricArt?.backgroundImage ?? {};
  const isMp4 = backgroundImage?.src?.endsWith('.mp4');
  const isGif = backgroundImage?.src?.endsWith('.gif');
  const uyoVideo = fabricArt?.objects?.find(
    (obj) => obj.type === 'uYOImage' && obj.src?.split('?').pop().endsWith('.mp4')
  );
  const frameImage = uyoVideo ? fabricArt?.objects?.find((obj) => obj.type === 'image') : null;

  useEffect(() => {
    if (uyoVideo && videoRef?.current) {
      const {offsetWidth} = videoRef.current;
      const zoom = offsetWidth / DEFAULT_TEMPLATE_WIDTH;
      const scale = 10;

      const baseWidth = uyoVideo.width * (uyoVideo.scaleX || 1);
      const baseHeight = uyoVideo.height * (uyoVideo.scaleY || 1);

      const newWidth = `${baseWidth / scale}%`;
      const newTop = `${(uyoVideo.top - baseHeight / 2) * zoom}px`;
      const newLeft = `${(uyoVideo.left - baseWidth / 2) * zoom}px`;

      setVideoStyles({
        width: newWidth,
        top: newTop,
        left: newLeft,
        transform: `rotate(${uyoVideo.angle}deg)`,
      });
    }
  }, [uyoVideo, videoRef?.current]);

  return {
    videoStyles,
    isMp4,
    isGif,
    uyoVideo,
    frameImage,
    backgroundImage,
  };
};
